<div class="mt-6">
  <form [formGroup]="form" (ngSubmit)="sendRequest()">
    <label class="font-bold">Chips:</label>
    <input type="number" class="default-input sm:ml-2" name="chips" formControlName="chips" />
    <br />
    <br />
    <button [disabled]="!form.valid" class="btn-success-v2 w-full" type="submit">
      Submit Request
    </button>
  </form>
</div>
